import {Adapter} from "../adapter/adapter";

export class PagesHelper<T> {
  public list: Array<T>;
  public numberOfPages: number;

  constructor(pagesHelper: PagesHelper<any>, adapter?: Adapter<T>){
    if(pagesHelper.list != null) {
      if (adapter != null) {
        this.list = pagesHelper.list.map(o => adapter.adaptIn(o));
      } else {
        this.list = pagesHelper.list;
      }
    }
    this.numberOfPages = pagesHelper.numberOfPages || 0;
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/shared-module/pagination/pages-helper.ts